import { BillStatus } from '@rematter/frontend-lib-api-client';
import { maybe } from '@rematter/ui-web';
import omit from 'lodash/omit';

import {
  createQueryAtomFactory,
  QueryAtomResult,
} from '~/shared/providers/api/createQueryAtomFactory';

export type BillRecord = QueryAtomResult<
  typeof billListQueryAtom
>['bills'][number];

export const billListQueryAtom = createQueryAtomFactory(
  'customerPortal.billList',
  (params: {
    status: BillStatus[];
    searchTerm?: string;
    pagination?: {
      limit: number;
      offset?: number;
    };
  }) => ({
    bills: {
      __args: {
        filter: {
          searchTerm: params.searchTerm,
          statuses: params.status,
        },
        pagination: maybe(params.pagination, (pagination) => ({
          limit: pagination.limit,
          offset: pagination.offset ?? 0,
        })),
      },
      page: {
        total: true,
      },
      entries: {
        __scalar: true,
        account: {
          __scalar: true,
          accountManagers: {
            id: true,
            firstName: true,
            lastName: true,
          },
        },
        amount: {
          __scalar: true,
        },
      },
    },
  }),
  {
    select: ({ bills }) => ({
      total: bills.page.total ?? 0,
      bills: bills.entries.map((bill) => ({
        ...omit(bill, ['account']),
        supplier: bill.account,
      })),
    }),
  },
);
